
import React, { Component } from 'react';
import './App.css';



class Goal extends Component {
  render() { 
    return (
	<div className="Goal">
	<b>Summary:</b> {this.props.children}
	</div>
	);
  }
}

class Location extends Component {
  render() { 
    return (
	<div className="Location">
	<b>Location:</b> {this.props.location}
	</div>
	);
  }
}

// This will be used to show top info 
// Name, Address, Phone, Email.


class Objective extends Component {
   render() { 
     return (
	 <div className="Objective">
	 <Goal {...this.props} />
	 <div></div>
	 <Location {...this.props} />
	 </div>
     );
   }
}

export default Objective;



// WEBPACK FOOTER //
// ./src/Objective.js